import React from 'react'
import './MainView.scss'
import dotenv from 'dotenv'

dotenv.config()

const key = process.env.GOOGLE_KEY

let firstImg = true

async function getUrl(word: string) {
  const GoogleImages = require('google-images')
  const client = new GoogleImages(
    'a11cc7849e0687d08',
    'AIzaSyBCqXjPrcNq32eWBg7MKKzmskgmaBCKNK4'
  )
  console.log(key)
  return await client.search(word).then((images: any) => {
    const randImg = Math.floor(Math.random() * images.length)
    return images[randImg].url
  })
}
export const MainView = React.memo(function MainView() {
  const textString = [
    'The wind is not the only thing moving. the trees are all bare and jack\'s come home and make something else',
    'A woman\'s life when the wind is gone and the tin in a sea breeze.',
    'And then for me with my father & as the poet. watch a few old paint records you made up',
    'I know the world like i know the kitchen',
    'It takes a single limb',
    'My face and now name. though i don\'t connect at home',
    'deplor­able is often with delight',
    'That will write a punctured cycle; a blue tree of you',
    '\' s life in all is me',
    'On error my hair snakes. i it thought backward',
    'You let clothes erode and there a voice can collect',
    'Ana you / hunched for our house —',
    'I then came to the doorway: it is a chilly house',
    'As i walk in the valley where j said isaiah\'s wife came to the doorway',
    '* i couldn\'t help like this: didactic the world away from the neck in my life and the delirium where you picked not to speak',
    'Of his long scraped attitudes who are a ukranian and my mouth',
    'The sun floods earth — and i wonder if i could dip my hand in its gut',
    'With every morning\'s life you turn toward hibernia',
    'For everyone to read the empty spaces the dead cannot kill',
    'And then it rose',
    'On some other air they swung from beneath the sun',
    'Formula is what becomes strength',
    'Tuberculosis is not uncommon in this life',
    'Elderly are the alps',
    'For that it opposes it recluses',
    'With every morning he wants it to speak against this place where there is no sunset',
    'Blade on my gums: a new prophet is me',
    'Quill and bone: against the gleaming missiles',
    'With every day i think',
    'The wind is not the only thing moving the trees are all bare and jack\'s come home and make something else and drop a heavy platter by mistake to assume i\'m the baby about the beautiful small things',
    'Quizzical the man is represented by each of the three magi in this story',
    'Ridged pine beams by the beauty of the husband — carefully not looking at a rock but a slab of night',
  ]
  const rand = Math.floor(Math.random() * textString.length)
  const [message, setMessage] = React.useState(textString[rand])
  let oldMessage = message
  const oldOpacity = '0.5'
  const word = message.split(' ')
  const randWordInt = Math.floor(Math.random() * word.length)
  const randWord = word[randWordInt] + 'before:2010'
  if (firstImg) {
    getUrl(randWord).then(function(result) {
      const addStr =
        '<img src=' +
        result +
        ' height="300" style="display: block; margin-left: auto; margin-right: auto; opacity: ' +
        oldOpacity +
        '; position: absolute; top:50%; left: 50%; transform: translate(-50%, -50%);"/>'
      document.getElementById('imagesContainer')!.innerHTML += addStr
    })
    firstImg = false
  }
  oldMessage = message
  function addNewMessage() {
    const newRand = Math.floor(Math.random() * textString.length)
    setMessage(textString[newRand])
    const newWord = message.split(' ')
    const newrandWordInt = Math.floor(Math.random() * newWord.length)
    const newRandWord = newWord[newrandWordInt] + 'before:2010'
    getUrl(newRandWord).then(function(result) {
      const addStr =
        '<img src=' +
        result +
        ' height="300" style="display: block; margin-left: auto; margin-right: auto; opacity: ' +
        oldOpacity +
        '; position: absolute; top:50%; left: 50%; transform: translate(-50%, -50%);"/>'
      document.getElementById('imagesContainer')!.innerHTML += addStr
    })
  }
  const subject = 'My COMPUTER 💻 Just Gave Me A Message ♡ ✰'
  const body =
    'A website 🤖 told me 🗯 that \n"' +
    oldMessage +
    '" 😲💌 Learn the universe\'s wisdom as interpreted through the algorithm at fortuneteller-23ce6.web.app 🙌'
  const href = 'mailto:?subject=' + subject + '&body=' + body
  return (
    <div>
      <a href={href} target="_blank" rel="noreferrer" className="centerLink">
        <div className="centered">{message}</div>
      </a>
      <div className="imagesContainer" id="imagesContainer" onClick={addNewMessage}></div>
    </div>
  )
})
